import { Store } from 'redux';

let store: Store<any>;

export const registerStore = (appStore: Store<any>) => {
  store = appStore;
};

export const getStore = () => store;
